import React from "react";
import { FaCheckCircle, FaMapMarkedAlt, FaReceipt, FaTools } from "react-icons/fa";
import googlePlay from "../assets/play.svg";
import appStore from "../assets/apple.svg";
import appImage from "../assets/carmie-phoneblack.png";

const appMoments = [
  {
    label: "Describe the issue",
    detail: "Tell Carmie what happened before you start calling around.",
    icon: FaTools,
  },
  {
    label: "Choose a service route",
    detail: "Garage visit, roadside support, or towing can live in one flow.",
    icon: FaMapMarkedAlt,
  },
  {
    label: "Keep the job record",
    detail: "Diagnosis, quote, payment, and review stay attached to the vehicle.",
    icon: FaReceipt,
  },
];

export default function GetTheApp() {
  return (
    <div className="relative overflow-hidden bg-[#EFF4EA] py-24 text-[#111714]">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 sm:px-8 lg:grid-cols-[minmax(0,0.9fr)_minmax(360px,0.8fr)] lg:px-12">
        <div>
          <p className="mb-4 inline-flex rounded-full bg-[#DCEFD2] px-4 py-2 text-xs font-black uppercase tracking-[0.18em] text-[#2D5B22]">
            Driver app
          </p>
          <h2 className="max-w-2xl text-4xl font-black leading-[1.02] sm:text-5xl lg:text-6xl">
            The job starts before the bonnet opens.
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-8 text-[#4E5D50]">
            Carmie turns a vehicle problem into a trackable service request:
            location, garage match, job notes, and payment trail in one place.
          </p>

          <div className="mt-8 grid gap-3">
            {appMoments.map((moment) => {
              const Icon = moment.icon;
              return (
                <div
                  key={moment.label}
                  className="grid grid-cols-[42px_minmax(0,1fr)] gap-4 border-l-2 border-[#8FE85E] bg-white/70 px-4 py-4"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#111714] text-[#8FE85E]">
                    <Icon aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="font-black">{moment.label}</h3>
                    <p className="mt-1 text-sm leading-6 text-[#5D6B5F]">
                      {moment.detail}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-8 rounded-md border border-[#D2DEC9] bg-[#F9FBF5] p-4">
            <div className="flex items-start gap-3">
              <FaCheckCircle className="mt-1 shrink-0 text-[#3D7E2C]" aria-hidden="true" />
              <div>
                <p className="font-black">Public store launch is being prepared.</p>
                <p className="mt-1 text-sm leading-6 text-[#5D6B5F]">
                  Store links are placeholders for now; this section is written
                  for the launch state instead of pretending the app is live.
                </p>
              </div>
            </div>
            <div className="mt-4 flex flex-col gap-3 sm:flex-row">
              <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer">
                <img src={googlePlay} alt="Google Play Store" className="w-40" />
              </a>
              <a
                href="https://apps.apple.com/us/app/apple-store/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={appStore} alt="Apple App Store" className="w-40" />
              </a>
            </div>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-[420px]">
          <div className="absolute -left-5 top-16 hidden w-48 rounded-md bg-[#111714] p-4 text-white shadow-xl sm:block">
            <p className="text-xs font-black uppercase tracking-[0.16em] text-[#8FE85E]">
              Request
            </p>
            <p className="mt-2 text-sm font-bold">Roadside support near Kira Road</p>
          </div>
          <div className="absolute -right-5 bottom-16 hidden w-48 rounded-md border border-[#D8E5D0] bg-white p-4 shadow-xl sm:block">
            <p className="text-xs font-black uppercase tracking-[0.16em] text-[#53724D]">
              Record
            </p>
            <p className="mt-2 text-sm font-bold">Quote, payment, review attached</p>
          </div>
          <div className="rounded-[28px] bg-[#111714] p-3 shadow-2xl">
            <img
              src={appImage}
              alt="Carmie app vehicle service screen"
              className="w-full rounded-[22px] bg-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
